<template>
  <div class="sidebar" v-show="show">
    <transition name="fade" mode="out-in">
      <ul class="side-menu" v-if="show">
        <li @click="$router.push('/home')">首页</li>
        <li @click="$router.push({path: '/disease?activeTab=0'})">疾病风险</li>
        <li @click="$router.push({path: '/inherit'})" v-show="sample_type !== 'childgsa' && sample_type !== 'chrgsa'">单基因病</li>
        <li @click="$router.push({path: '/rare'})" v-show="gdb3 && sample_type !== 'wgs' && sample_type !== 'wes' && sample_type !== 'gsa' && sample_type !== 'asa' && sample_type !== 'chrgsa' && sample_type !== 'wesplus' && sample_type !== 'childgsa' && sample_type !== 'childasa'">可治罕见病</li>
        <li @click="$router.push({path: '/drug?activeTab=0'})" v-show="sample_type !== 'chrgsa' && sample_type !== 'childwes_zy'">精准用药</li>
        <li @click="$router.push({path: '/talent?activeTab=0'})" v-show="sample_type !== 'chrgsa'">特质基因</li>
      </ul>
    </transition>
    <div class="shadow"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      gdb3: false,
      gdb2: false,
      sample_type: this.util.getLS(this.api.sample_type)
    }
  },
  props: ['show', 'child'],
  mounted () {
    if (this.util.getLS(this.api.status) === 1) {
      this.gdb3 = true
    } else {
      this.gdb2 = true
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/functions";
  .sidebar, .sidebar .shadow {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  .sidebar {
    position: fixed;
    z-index: 999;
  }
  .sidebar .shadow,
  .sidebar .side-menu {
    position: absolute;
  }
  .sidebar .side-menu {
    top: 0;
    right: 0;
    height: 100%;
    width: 40%;
    background-color: #383E47;
    padding: pxToRem(50px) pxToRem(30px) pxToRem(30px);
    z-index: 1000;
    transition: all .5s;
  }
  .shadow {
    background-color: rgba(0, 0, 0, .3);
  }
  .sidebar .side-menu li {
    color: #fff;
    padding: pxToRem(14px) 0;
    border-bottom: 0.5px solid #494F59;
    font-size: pxToRem(28px);
    margin-bottom: pxToRem(30px);
  }
  .sidebar .side-menu .close {
    border-bottom-width: 0;
    text-align: right;
  }
  .sidebar .side-menu .close .icon {
    width: pxToRem(30px);
  }

  .fade-enter-active {
    transition: all .3s ease;
  }
  .fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .fade-enter, .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/SideBar.vue